<template>
  <b-modal
    title="Select Educational Resource"
    hide-header
    hide-footer
    centered
    :visible="show"
    @hide="$emit('dismiss')"
  >
    <div>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Skills">
            <b-form-checkbox-group
              name="skills"
              v-model="skills"
              :options="skillOptions"
              :disabled="loading"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="loading">
        Loading Resources
      </div>
      <div v-if="results.length === 0 && !loading">
        No resources found
      </div>
      <div v-for="resource in results" :key="resource.uuid">
        <educational-item-summary
          :resource="resource"
          actionTitle="Select"
          v-on:action-button-tapped="$emit('resource-selected', resource)"
        ></educational-item-summary>
      </div>
    </div>
    <div
      v-if="results.length > 0 && !loading && canLoadMore"
      class="d-flex justify-content-center"
    >
      <b-btn variant="secondary" size="sm" @click="loadMoreTapped()">
        Load more
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
/**
 * All components
 * - Selection Modal
 * - Selection List Item?
 * - Search Bar?
 * - Educational Item Summary (Small item to insert into meeting confirmation and creation modals)
 *
 * Selection Modal
 * Needs output for selected items. Send full, to enable summary in meeting modal
 * Search bar (no filtering?)
 * Pagination? (Maybe simple, view next page?)
 * Opens item in new tab if selected
 * For now, each list item will have a select button and close out. Can add multiselection support later
 *
 * Search Bar
 * Set up general search bar, to add search capabilities to other views
 * Share design language and keep outputs consistent
 * Add in capability to auto return with debounce later on
 *
 * Selection List item? May be overkill in this case
 * Should just be a simple table row, unless using more detailed list item from inset
 * Start with table for sure
 *
 * Educational Item Summary (better class name)
 * Simple component that shows title, description, resource type, rating?, skills, creator?
 * Need optional action inputs, or set choices (Remove from meeting, View Details)
 * Takes an input of an educational item, required
 *
 */

import EducationalItemSummary from './EducationalItemSummary'
export default {
  name: 'EducationalItemSelectionModal',
  components: {
    EducationalItemSummary,
  },
  props: {
    show: Boolean,
  },
  mounted() {
    this.load()
  },
  watch: {
    skills() {
      this.page = 1
      this.load()
    },
  },
  data() {
    return {
      loading: false,
      searchText: '',
      skills: [],
      page: 0,
      results: [],
      skillOptions: [
        { text: 'Finance', value: '1' },
        { text: 'Legal', value: '2' },
        { text: 'HR', value: '3' },
        { text: 'Strategy', value: '4' },
        { text: 'Ops', value: '5' },
        { text: 'Tech', value: '6' },
        { text: 'Mktg/Sales', value: '7' },
        { text: 'Buy/Sell', value: '8' },
        { text: 'Franch', value: '9' },
        { text: 'Intl', value: '10' },
        { text: 'Govt', value: '11' },
      ],
      canLoadMore: true,
      pageCount: 25
    }
  },
  methods: {
    load() {
      this.loading = true
      this.$http
        .get('resources', {
          params: {
            page: this.page,
            page_count: this.pageCount,
            sort_key: 'id',
            sort_order: 'DESC',
            skills: this.skills,
            title: this.searchText,
          },
        })
        .then(
          (res) => {
            this.canLoadMore = res.data.data.length >= this.pageCount
            if (this.page == 1) {
              this.results = res.data.data
            } else {
              this.results = this.results.concat(res.data.data)
            }
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    loadMoreTapped() {
      this.page += 1
      this.load()
    }
  },
}
</script>

<style></style>
